import * as React from "react"
import { SwitchSeeker } from "@ui-seeker/core"


export default function ResultsChangeSwitch({ showDiff, onChange, ...props }) {
    return <SwitchSeeker
        checked={showDiff}
        onChange={onChange}
        label='Only Changes'
        {...props}
    />
}